<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>专业分类管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="tab-wrap">
        <ul>
          <li
            @click="asdSwitch(1)"
            :class="{'on':tabIndex==1}"
          >专业大类管理</li>
          <li
            @click="asdSwitch(2)"
            :class="{'on':tabIndex==2}"
          >专业管理</li>
        </ul>
      </div>
      <div id="searchSection">
        <div class="search-line clearfix">
          <div v-if="tabIndex==1">
            <select
              class="s-select separate"
              v-model="categoryQueryInfo.status"
            >
              <option value="">专业大类状态</option>
              <option value="0">禁用</option>
              <option value="1">启用</option>
            </select>
            <input
              type="text"
              placeholder="专业大类名称"
              class="s-input separate"
              v-model="categoryQueryInfo.title"
            >
            <input
              type="button"
              value="搜索"
              class="s-btn"
              @click="pageCallback(1)"
            >
          </div>
          <div v-if="tabIndex==2">
            <select
              class="s-select separate"
              v-model="subjectQueryInfo.status"
            >
              <option value="">专业状态</option>
              <option value="0">禁用</option>
              <option value="1">启用</option>
            </select>
            <input
              type="text"
              placeholder="专业名称"
              class="s-input separate"
              v-model="subjectQueryInfo.title"
            >
            <input
              type="button"
              value="搜索"
              class="s-btn"
              @click="pageSubjectCallback(1)"
            >
          </div>

          <div
            class="add-btn"
            style="margin-bottom:0;"
            @click="showAddWindow(tabIndex,'add')"
          >新建</div>
          <!-- <div
            class="import-btn"
            id="batchUpload"
            @click="showUploadWindow"
          >导入</div> -->
        </div>

      </div>
      <div id="list">
        <div v-if="tabIndex==1">
          <table>
            <tbody>
              <tr class="l_header">
                <th class="itemStatus">编号</th>
                <th class="itemStatus">专业大类名称</th>
                <th class="itemStatus">专业数量</th>
                <th class="itemStatus">状态</th>
                <th
                  class="action"
                  width="180"
                >操作</th>
              </tr>
              <tr
                class="item"
                v-for="item in tableData"
                :key="item.id"
              >
                <td class="itemStatus">{{item.code}}</td>
                <td class="itemStatus">{{item.title}}</td>
                <td class="itemStatus">{{item.subject_count}}</td>
                <td :class="'itemStatus itemStatus' + item.status">{{ item.status == 1 ? '已启用' : '禁用' }}</td>
                <td class="action">
                  <a
                    class="edit"
                    href="javascript:;"
                    @click="querySingle(item.id,tabIndex)"
                  >编辑</a>
                  <a
                    v-if="item.status==1"
                    class="nopublish"
                    href="javascript:;"
                    @click="unpublish(item,tabIndex)"
                  >禁用</a>
                  <a
                    v-if="item.status==0"
                    class="publish"
                    href="javascript:;"
                    @click="publish(item,tabIndex)"
                  >启用</a>
                  <a
                    class="delete"
                    href="javascript:;"
                    @click="askNoDelete"
                    v-if="item.subject_count>0"
                  >删除</a>
                  <a
                    class="delete"
                    href="javascript:;"
                    @click="askDelete(item.id)"
                    v-else
                  >删除</a>
                </td>
              </tr>
            </tbody>
            <tr
              class="noitems"
              v-if="!tableData.length"
            >
              <td colspan="5">没有数据</td>
            </tr>
          </table>
          <!-- 分页 -->
          <pagination
            :cur='pageInfo.page'
            :all='pageInfo.all'
            :totalData="pageInfo.totalData"
            :callback="pageCallback"
          ></pagination>
        </div>
        <div v-if="tabIndex==2">
          <table>
            <tbody>
              <tr class="l_header">
                <th class="itemStatus">专业编号</th>
                <th class="itemStatus">专业名称</th>
                <th class="itemStatus">所属专业大类</th>
                <th class="itemStatus">状态</th>
                <th
                  class="action"
                  width="180"
                >操作</th>
              </tr>
              <tr
                class="item"
                v-for="item in subjectTableData"
                :key="item.id"
              >
                <td class="itemStatus">{{item.code}}</td>
                <td class="itemStatus">{{item.title}}</td>
                <td class="itemStatus">{{item.subject_category.title}}</td>
                <td :class="'itemStatus itemStatus' + item.status">{{ item.status == 1 ? '已启用' : '禁用' }}</td>
                <td class="action">
                  <a
                    class="edit"
                    href="javascript:;"
                    @click="querySingle(item.id,tabIndex)"
                  >编辑</a>
                  <a
                    v-if="item.status==1"
                    class="nopublish"
                    href="javascript:;"
                    @click="unpublish(item,tabIndex)"
                  >禁用</a>
                  <a
                    v-if="item.status==0"
                    class="publish"
                    href="javascript:;"
                    @click="publish(item,tabIndex)"
                  >启用</a>
                  <a
                    class="delete"
                    href="javascript:;"
                    @click="askDle(item)"
                  >删除</a>
                </td>
              </tr>
            </tbody>
            <tr
              class="noitems"
              v-if="!subjectTableData.length"
            >
              <td colspan="5">没有数据</td>
            </tr>
          </table>

          <!-- 分页 -->
          <pagination
            :cur='pageSubjectInfo.page'
            :all='pageSubjectInfo.all'
            :totalData="pageSubjectInfo.totalData"
            :callback="pageSubjectCallback"
          ></pagination>
        </div>
      </div>

      <!-- 专业添加/编辑弹窗 -->
      <div
        class="form_overlay"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>
        <!-- 专业大类管理 -->
        <div
          class="form_panel"
          v-if="tabIndex==1"
        >
          <div class="form_title">专业大类管理</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>编号:</span>
                <input
                  type="hidden"
                  v-model="categoryInfo.id"
                >
                <input
                  type="text"
                  v-model="categoryInfo.code"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>专业大类名称:</span>
                <input
                  type="text"
                  v-model="categoryInfo.title"
                  maxlength="25"
                >
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveCategoryInfo"
            >提交</a>
          </div>
        </div>
        <!-- 专业管理 -->
        <div
          class="form_panel"
          v-if="tabIndex==2"
        >
          <div class="form_title">专业管理</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>专业编号:</span>
                <input
                  type="text"
                  v-model="subjectInfo.code"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>专业名称:</span>
                <input
                  type="text"
                  v-model="subjectInfo.title"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>所属专业大类:</span>
                <select v-model="subjectInfo.subject_category_id">
                  <option value="">选择专业大类</option>
                  <option
                    v-for="item in tableData"
                    :key="item.id"
                    :value="item.id"
                  >{{item.title}}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        class="form_overlay"
        :style="classShowUploadWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">批量上传</div>
          <div class="form_content">
            <form id="uploadForm">
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                ><i class="require"></i>模版创建规则:</span>
                <div class="item-box divLabel gray">
                  <div class="normal-width">
                    <p>1. 文件格式为常用的Excel文件（*.xlsx或*.xls）；</p>
                    <p>2. 填写导入数据时，需先删除导入模版中首行以下所有说明示例数据，且第二行中文说明字段前带*号的为必填项；</p>
                    <p>3. 导入文件中如存在多个sheet工作表，表头应与示例工作表表头完全一致；</p>
                    <p>4. 导入的数据总条数不得超过2000条，如超过，则需分多次导入；</p>
                    <p>5. 注意：请保证“专业”所属“父级编号”的学院信息位置在前。</p>
                  </div>
                </div>
                <div class="clear"></div>
                <div class="attachment">
                  <a
                    href="/static/upload_template/batch_upload_major_template.csv"
                    download="batch_upload_user_template.csv"
                    target="_blank"
                  >模版下载</a>
                </div>
              </div>
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                ><i class="require">*</i>CSV文件:</span>
                <div
                  class="item-box"
                  style="margin-left: 130px;"
                >
                  <input
                    v-model="uploadedCsv"
                    disabled
                    type="text"
                    id="fileUrl"
                    style="width: 225px;"
                  >
                  <span
                    class="button"
                    style="position: relative;top: 0px; left: 0px;"
                  >
                    选择文件
                    <input
                      @change="xlsChange"
                      type="file"
                      accept=".csv,.xls,.xlsx"
                      ref="xlsFile"
                      id="fileUpload"
                      class="upload-derict"
                    >
                  </span>
                </div>
                <div class="clear"></div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              style="width: 30px"
              class="button close"
              id="form_upload_close"
              @click="hideUploadWindow"
            >取消</a>
            <a
              href="javascript:;"
              style="width: 30px"
              class="button"
              id="form_upload_submit"
              @click="submitCsv"
            >提交</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'User',
  components: {
    Pagination
  },
  data() {
    return {
      tabIndex: 1,
      classShowAddWindow: {},
      classShowUploadWindow: {},
      tableData: [],
      subjectTableData: [],
      categoryQueryInfo: {
        page: 1,
        size: 10,
        status: '',
        title: ''
      },
      subjectQueryInfo: {
        page: 1,
        size: 10,
        status: '',
        title: ''
      },
      tableDataCount: 0, // 专业大类列表总数据
      subjectTableDataCount: 0, // 专业列表总数据
      categoryInfo: { // 专业大类表单数据
        id: 0,
        code: '',
        title: ''
      },
      subjectInfo: { // 专业表单数据
        id: 0,
        code: '',
        title: '',
        subject_category_id: ''
      },
      uploadedCsv: '',
      errorList: [],
      uploadedCscData: [],
      isFinishUpsert: false,
      curCsvUserId: 0,
      curCsvIndex: 0,
      csvFinishText: ''
    }
  },
  methods: {
    async xlsChange() {
      const uploadUrl = '/files/' + this.$refs.xlsFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.xlsFile.files[0]).then((data) => {
        this.uploadedCsv = data
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    asdSwitch(e) {
      this.tabIndex = e
      if (e === 2) {
        this.categoryQueryInfo = {
          page: 1,
          size: 10000,
          status: 1,
          title: ''
        }
        this.subjectQueryInfo = {
          page: 1,
          size: 10,
          status: '',
          title: ''
        }
        this.searchCategory()
        this.searchSubject()
      } else {
        this.categoryQueryInfo = {
          page: 1,
          size: 10,
          status: '',
          title: ''
        }

        this.searchCategory()
      }
    },
    // 专业大类分页
    pageCallback(data) {
      this.categoryQueryInfo.page = data
      this.searchCategory()
    },
    // 专业分页
    pageSubjectCallback(data) {
      this.subjectQueryInfo.page = data
      this.searchSubject()
    },
    // 打开专业添加/编辑弹窗
    showAddWindow(click, value) {
      if (click === 1 && value === 'add') {
        this.categoryInfo = { // 专业大类表单数据
          id: 0,
          code: '',
          title: ''
        }
      } else if (click === 2 && value === 'add') {
        this.subjectInfo = { // 专业表单数据
          id: 0,
          code: '',
          title: '',
          subject_category_id: ''
        }
      }
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭专业添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
    },
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    // 禁用
    unpublish(item, click) {
      this.$parent.showConfirm('确定要禁用该记录吗？', () => {
        this.askDisable(item, 0, click)
      })
    },
    // 启用
    publish(item, click) {
      this.$parent.showConfirm('确定要启用该记录吗？', () => {
        this.askDisable(item, 1, click)
      })
    },
    // 禁用
    async askDisable(item, status, click) {
      const msg = status === 0 ? '禁用' : '启用'
      var params
      if (click === 1) {
        params = {
          status: status
        }
      } else {
        params = {
          status: status,
          subject_category_id: item.subject_category_id
        }
      }

      const url = click === 1 ? '/subject_category/' + item.id + '/' : '/subject/' + item.id + '/'
      await this.$http.put(url, params).then((data) => {
        this.$parent.showMsg(msg + '成功！')
        if (click === 1) {
          this.searchCategory()
        } else if (click === 2) {
          this.searchSubject()
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg(msg + '失败！')
      })
    },

    async searchCategory() {
      await this.$http.get('/subject_category/', {
        params: this.categoryQueryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },

    async searchSubject() {
      await this.$http.get('/subject/', {
        params: this.subjectQueryInfo
      }).then((data) => {
        this.subjectTableData = data.results
        this.subjectTableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 新增/编辑专业
    async saveInfo() {
      if (!this.subjectInfo.code) {
        this.$parent.showMsg('请输入编号!')
        return false
      }
      if (!this.subjectInfo.title) {
        this.$parent.showMsg('请输入专业名称!')
        return false
      }

      if (this.subjectInfo.id) {
        const url = '/subject/' + this.subjectInfo.id + '/'
        await this.$http.put(url, this.subjectInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.searchSubject()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        await this.$http.post('/subject/', {
          code: this.subjectInfo.code,
          title: this.subjectInfo.title,
          subject_category_id: this.subjectInfo.subject_category_id,
          status: 1
        }).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.searchSubject()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 新增/编辑专业大类
    async saveCategoryInfo() {
      if (!this.categoryInfo.code) {
        this.$parent.showMsg('请输入编号!')
        return false
      }
      if (!this.categoryInfo.title) {
        this.$parent.showMsg('请输入专业大类名称!')
        return false
      }

      if (this.categoryInfo.id) {
        const url = '/subject_category/' + this.categoryInfo.id + '/'
        await this.$http.put(url, this.categoryInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.searchCategory()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        await this.$http.post('/subject_category/', {
          code: this.categoryInfo.code,
          title: this.categoryInfo.title,
          status: 1
        }).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.searchCategory()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 编辑时查询
    async querySingle(id, click) {
      const url = click === 1 ? '/subject_category/' + id + '/' : '/subject/' + id + '/'
      await this.$http.get(url).then((data) => {
        if (click === 1) {
          this.categoryInfo = {
            id: id,
            code: data.code,
            title: data.title,
            isdel: 0
          }
        } else {
          this.subjectInfo = {
            id: id,
            code: data.code,
            title: data.title,
            subject_category_id: data.subject_category_id
          }
        }

        this.showAddWindow()
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    askNoDelete() {
      this.$parent.showMsg('该专业大类下面有专业,暂时无法删除！')
    },
    // 删除专业大类
    async askDelete(id) {
      const url = '/subject_category/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.searchCategory()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    // 删除专业
    async askDle(item) {
      const url = '/subject/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1,
          subject_category_id: item.subject_category_id
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.searchSubject()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    async submitCsv() {
      const uploadUrl = '/get_csv/'
      await this.$http.get(uploadUrl, {
        params: {
          file_name: this.uploadedCsv
        }
      }).then((data) => {
        if (data.length <= 1) {
          this.$parent.showMsg('表格中无数据！')
          return
        }

        data.splice(0, 1)

        this.uploadedCscData = data

        this.hideUploadWindow()

        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()
      }).catch(() => {
        this.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {
      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.tabIndex === 1 ? this.searchCategory() : this.searchSubject()
        return
      }

      const row = this.uploadedCscData[this.curCsvIndex]
      const studentIds = this.tableData.map(item => item.code)
      // region 数据检查开始

      if (row[0].trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[0] + ']' + '请输入编号！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[1].trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '请输入专业大类名称！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      if (row[2].trim().length === 0 && this.tabIndex === 2) {
        this.errorList.push({ code: 0, text: '[' + row[2] + ']' + '请输入专业大类编号！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      if (row[2].trim().length > 0 && this.tabIndex === 1) {
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      const url = this.tabIndex === 1 ? '/subject_category/' : '/subject/'
      var addForm
      if (this.tabIndex === 1) {
        addForm = {
          code: row[0],
          title: row[1]
        }
      } else {
        if (studentIds.indexOf(row[2]) < 0) {
          this.$parent.showMsg('您填写的专业大类编码所在数据没被启用或未被创建,无法导入！')
          return
        } else {
          addForm = {
            code: row[0],
            title: row[1],
            subject_category_id: this.tableData[studentIds.indexOf(row[2])].id
          }
        }
      }

      await this.$http.post(url, addForm).then(async (data) => {
        this.errorList.push({ code: 1, text: '[' + addForm.title + ']' + '导入成功！' })
        this.curCsvIndex++
        this.insertOne()
      }).catch((error) => {
        console.dir(error)
        this.errorList.push({ code: 0, text: '[' + addForm.title + ']' + error.response.data[0] })
        this.curCsvIndex++
        this.insertOne()
      })
    }

  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.categoryQueryInfo.page,
        all: Math.ceil(this.tableDataCount / this.categoryQueryInfo.size),
        totalData: this.tableDataCount
      }
    },
    pageSubjectInfo() {
      return {
        page: this.subjectQueryInfo.page,
        all: Math.ceil(this.subjectTableDataCount / this.subjectQueryInfo.size),
        totalData: this.subjectTableDataCount
      }
    }
  },
  mounted() {
    this.searchCategory()
    this.searchSubject()
  }
}
</script>

<style scoped>
.tab-wrap ul li.on,
.tab-wrap ul li:hover {
  border-bottom: 2px solid #73D6CA;
  color: #73D6CA;
}
</style>
